export interface IVehicleConsumable {
	group: VehicleConsumableGroup;
	healthPercent: number;
}

export enum VehicleConsumableGroup {
	MOTOR_OIL = 'motor_oil',
	TRANSMISSION_OIL = 'transmission_oil',
	BRAKE_PADS = 'brake_pads',
	TIRES = 'tires',
}
